import { Component, useRef } from 'react';
import { Accordion, Divider, Grid, Icon, Segment } from 'semantic-ui-react';
import { useWikiSearch } from '../WikiSearchContext';
import useHighlightMatches from '../useHighlightMatches';

class BhpGuideClass extends Component {
  state = { activeIndex: [0, 1, 2, 3, 4, 5] };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;

    const newIndex = activeIndex.includes(index)
      ? activeIndex.filter((i) => i !== index)
      : [...activeIndex, index];

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const { contentRef } = this.props;

    return (
      <div ref={contentRef}>
        <Grid id="detailed-segment">
          <Grid.Column width={16}>
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Accordion styled fluid id="segment" exclusive={false}>
                  <Accordion.Title
                    active={activeIndex.includes(0)}
                    index={0}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Why do we need documentation?
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(0)}>
                    <ul>
                      <li>
                        Our clients depend on your accurate documentation in
                        order to continue receiving services.
                      </li>
                      <li>
                        Our clients depend on your documentation to also qualify
                        for future services.
                      </li>
                      <li>
                        Writing your narratives immediately ensures they are
                        accurate and not just filled out later to get them done.
                      </li>
                      <li>DHHS routinely conducts audits.</li>
                    </ul>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(1)}
                    index={1}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Prompts 101
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(1)}>
                    <ol>
                      <li style={{ color: 'red' }}>Independent</li>
                      <ul id="dark-blue">
                        Client performed behavior without prompting
                      </ul>
                      <ul style={{ fontStyle: 'italic' }} id="orange">
                        Client put his shoes by the door without prompting
                      </ul>

                      <li style={{ color: 'orange' }}>Indirect Verbal</li>
                      <ul id="dark-blue">
                        Client was indirectly asked/told through a question
                      </ul>
                      <ul style={{ fontStyle: 'italic' }} id="orange">
                        “Where do your shoes go?”
                      </ul>

                      <li style={{ color: 'green' }}>Direct Verbal</li>
                      <ul id="dark-blue">
                        Client was directly told through a demand
                      </ul>
                      <ul style={{ fontStyle: 'italic' }} id="orange">
                        “Put your shoes by the door.”
                      </ul>

                      <li style={{ color: 'blue' }}>Gesture</li>
                      <ul id="dark-blue">Client was directed by gesture</ul>
                      <ul style={{ fontStyle: 'italic' }} id="orange">
                        I pointed to the shoes and then to the door.
                      </ul>

                      <li style={{ color: 'purple' }}>Hand-over Hand</li>
                      <ul id="dark-blue">
                        BHP moved Client’s hand(s) to perform appropriate task
                      </ul>
                      <ul style={{ fontStyle: 'italic' }} id="orange">
                        I picked up Client’s hand and we flushed the toilet
                        together.
                      </ul>

                      <li style={{ color: 'brown' }}>Refused</li>
                      <ul id="dark-blue">
                        Client refuses to adjust behavior after all other
                        prompts are attempted by BHP
                      </ul>
                      <ul style={{ fontStyle: 'italic' }} id="orange">
                        “Client refused to put his shoes by the door after
                        multiple prompts.”
                      </ul>
                    </ol>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(2)}
                    index={2}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    How to properly write session notes
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(2)}>
                    <i>
                      ** Within narrative, refer to which goal you are
                      narrating! **
                    </i>
                    <Divider />
                    <div>
                      <b style={{ color: 'blue' }}>Antecedent</b> ->{' '}
                      <b style={{ color: 'orange' }}>Behavior</b> ->{' '}
                      <b style={{ color: 'red' }}>CORRECTION</b> ->{' '}
                      <b style={{ color: 'green' }}>Response</b>
                      <br />
                      <h5>Direct Verbal Example:</h5>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <b style={{ color: 'blue' }}>
                        4.1 Mikey heard a noise outside of the house,
                      </b>{' '}
                      <b style={{ color: 'orange' }}>
                        he stood on a chair to see out the window.
                      </b>
                      <b style={{ color: 'red' }}> I said “sit on your bum”.</b>
                      <b style={{ color: 'green' }}> Mikey sat down.</b>
                    </div>
                    <Divider />
                    <h5 id="green">OR</h5>
                    <div>
                      <b style={{ color: 'orange' }}>Behavior</b> ->{' '}
                      <b style={{ color: 'red' }}>CORRECTION</b> ->{' '}
                      <b style={{ color: 'green' }}>Response</b>
                    </div>
                    <h5>Indirect Verbal Example:</h5>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <b style={{ color: 'orange' }}>
                      4.1 Mikey stood on a chair to see out the window.
                    </b>{' '}
                    <b style={{ color: 'red' }}>
                      {' '}
                      I said, “how are you supposed to be in a chair?”
                    </b>
                    <b style={{ color: 'green' }}> Mikey sat down.</b>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(3)}
                    index={3}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Tips & Tricks
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(3)}>
                    <h5 style={{ color: 'red' }}>
                      ALWAYS GET PARENT-GUARDIAN SIGNATURE WITHIN SHIFT
                    </h5>
                    <ul>
                      <li id="orange">
                        Set 5-10 minutes aside at the end of your shift to write
                        your notes.
                      </li>
                      <li id="orange">
                        Only sign your session AFTER you have completed the
                        prompts and narratives
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        If you are prone to forgetting, get their signature at
                        the beginning. Make it a habit!
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Do not go more than two sessions without signatures.
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        If they say they will sign on their own device but
                        rarely sign your shifts, take initiative and get their
                        signature on your device
                      </li>
                    </ul>

                    <h5 style={{ color: 'green' }}>
                      How can I write down what happened throughout the day if
                      my client is high energy/ a bolter?
                    </h5>
                    <ul>
                      <li id="orange">
                        Keep the Portal open on your phone AT ALL TIMES to
                        unlock and access quickly
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Wait until client is distracted (eating, playing with a
                        toy, using the bathroom, etc.) and add prompt levels to
                        relevant goals
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        HIT SUBMIT or it may be lost
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Write narratives at during the end of your shift. Having
                        the prompts there should help you recall what you did
                        for that specific goal
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Each narrative section can be 2-3 sentences if kept
                        concise and goals are referenced. Reference your
                        client’s goals in your narratives and use the goal
                        numbers (e.g. 1.2, 1.3, etc).
                      </li>
                    </ul>

                    <h5 style={{ color: 'grey' }}>
                      Overwhelmed with School, Home, Second/Third Job and cannot
                      complete session notes within the same day as your shift?
                    </h5>
                    <ul>
                      <li id="orange">
                        Select TWO days of the week where you will set aside
                        time to complete ALL backed-up session narratives
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Mark your calendars, go to React HQ, go to the
                        Library/Study Room, write on sticky notes and stick ‘em
                        to your car windshield, whatever you need to do to get
                        it done
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Distractions occur the most in a place where you
                        frequently allow it. Reiterated: You will have less
                        distractions in places that hold a business- or
                        school-like setting
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Get something to eat and drink and limit distractions
                        such as TV, social media, etc.
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Do not go more than four days without completing old
                        sessions
                      </li>
                    </ul>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(4)}
                    index={4}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Example Narratives
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(4)}>
                    <blockquote>
                      1.1 Client refused to make eye contact when engaged in
                      conversation with parents and BHP. Later client was able
                      to make eye contact but needed multiple direct verbal
                      prompts. 1.2 Initially, client refused to appropriately
                      express his wants and needs, despite multiple direct
                      verbal prompts. Later on, client was able to independently
                      appropriately express his wants/needs with occasional
                      indirect verbal prompting. 1.3 Client needed multiple
                      direct verbal prompts to respond to redirection of
                      negative self-talk; client repeatedly refused. 1.4 Client
                      refused to use effective coping strategies when frustrated
                      despite direct verbal prompting.
                    </blockquote>
                    <blockquote>
                      2.1 Client had difficulty identifying and responding to
                      certain social cues such as answering questions, when to
                      leave a situation, etc. Initially, client refused but
                      complied after multiple direct verbal prompts. 2.2 Client
                      needed direct verbal prompting to introduce appropriate
                      topics of conversation. 2.3 Client also needed direct
                      verbal prompting to play correctly and compatibly with
                      siblings while playing uno. 2.4 Client also needed direct
                      verbal prompting to share with his siblings. 2.5 Client as
                      able to independently seek and participate in an activity
                      of interest.
                    </blockquote>
                    <blockquote>
                      3.2 Anna washed her hands after both indirect prompts. I
                      said "we should wash our hands because we've been touching
                      mushrooms and plants". She brushed her teeth after her mom
                      asked her. She changed her clothes after being reminded of
                      the bedtime routine. 3.3 Anna immediately responded and
                      helped her mom and uncle with things they asked. 3.4 Anna
                      needed a light reminder to take her medication as she was
                      distracted. Anna was able to respond to conversations in a
                      timely manner.{' '}
                    </blockquote>
                    <blockquote>
                      1.1 There were a couple times where I asked Anna to repeat
                      what she said because she was facing away from us and was
                      talking quietly. I said "I didn't hear you
                      (indirect)"/"can you repeat that (direct)". She shared her
                      opinions and feelings about certain situations in a timely
                      manner. For example, while on a ride at the park she was
                      quiet and once it started she expressed "I want to get
                      off" and was patient enough to tell the instructor and she
                      waited for the ride to stop. 1.2 I asked Anna how she was
                      feeling while both on and off rides. She answered with
                      "good" or "I'm okay". At one point, Anna expressed "I feel
                      awesome!" After she got off another ride without
                      prompting. 1.4 Anna stated "I don't want to be on this
                      ride anymore" and I asked her if she wants me to help her
                      by telling the instructor to stop and she said yes.
                    </blockquote>
                    <blockquote>
                      2.1 Anna didn't need to be prompted to talk about
                      appropriate topics. 2.2 Anna greeted me from inside her
                      car window when her and her aunt pulled up to the park
                      area. At another time, she was trying to hand an
                      instructor tickets to get on the ride and she needed to be
                      indirectly prompted to not give him the tickets at a
                      certain time. I said "it's not time to give him the
                      tickets yet" and she pulled her hand away. 2.5 Anna tried
                      new coping strategies after I told her what I do. I said
                      "I breathe and squeeze my stomach muscles" when we were on
                      our first ride. I could audibly hear her breathing. She
                      was still death-gripping the railings so I asked her if I
                      could help her in any way, and she asked me to hold her.
                      2.6 Anna led her aunt and I around the park and chose
                      which rides she wanted to go on. She also needed help on
                      the first ride, and I accompanied her. Indirectly for
                      self-soothing, I asked her how I could help her and she
                      answered with what she wanted. Explained in 2.5
                    </blockquote>
                    <blockquote>
                      1.1: Client was asked to pick up toilet paper off the
                      floor that client had dropped, client expressed that it
                      was gross and that he wasn’t doing it, BHP gave a direct
                      verbal prompt expressing to client that it may be gross
                      but if he doesn’t like picking it up off the floor he
                      should make sure it makes it fully into the trash can.
                      1.6: client and bhp were talking about when he had seen a
                      certain item, client responded “on Saturdays” bhp used an
                      indirect verbal prompt saying are you sure you didn’t see
                      it yesterday? Client responded saying he wasn’t sure.
                    </blockquote>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(5)}
                    index={5}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    BHP Job Description
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(5)}>
                    <p>
                      As a BHP, you will be providing in-home, one-on-one
                      support to children with developmental disabilities and
                      behavioral health challenges, including but not limited to
                      autism, intellectual disability disorder (IDD), anxiety,
                      ADHD, PTSD, and depression. BHPs utilize an individualized
                      treatment plan that is specific to each child in order to
                      focus on personalized goals and maximize progress. A BHP
                      is responsible for implementing methods and strategies in
                      order to work on these outlined goals, and they are
                      responsible for noting all improvement and regression in
                      order to track progress. A BHPs dedication to the child’s
                      needs, and the desire to create a trusting and effective
                      relationship with the child and their family, are
                      essential in providing the quality of service that is
                      needed. Goals include:
                    </p>
                    <ul>
                      <li id="orange">
                        Provide in-home support services to children and their
                        families in the home and community settings with
                        particular emphasis on behavior management, skill
                        development, physical development and increasing the
                        child’s independence and daily living skills.
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Follow a detailed treatment plan with goals specific for
                        each child’s needs.
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Help to increase a child’s independence and working on
                        daily living skills.
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Be punctual and consistent.
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Be in compliance with trainings and supervisions with
                        supervisor.
                      </li>
                      <li style={{ fontStyle: 'italic' }} id="orange">
                        Follow the individual treatment plan and accurately
                        document services provided to the child and family.
                      </li>
                    </ul>
                  </Accordion.Content>
                </Accordion>
              </Segment>
            </Segment.Group>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const BhpGuide = (props) => {
  const { searchTerm } = useWikiSearch();
  const contentRef = useRef(null);
  useHighlightMatches(contentRef);

  return (
    <BhpGuideClass {...props} searchTerm={searchTerm} contentRef={contentRef} />
  );
};

export default BhpGuide;
